export default {
	"textarea.counter": "{length}/{maxLength}",
} as const;
